






























import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';

import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import { PayServiceModel } from '@/models/payservice';
import payserviceService from '@/services/payservice-services';
import authService from '@/services/auth-services';
import CustomerInfo from './components/CustomerInfo.vue';
import PayServiceDetailFooter from './components/PayServiceDetailFooter.vue';
import AmountDetailPayService from './components/AmountDetailPayService.vue';
import PayServiceInfo from './components/PayServiceInfo.vue';
import ChatBox from '@/shared/components/ChatBox.vue';

@Component({
    components: {
        'customer-info': CustomerInfo,
        'chat-box': ChatBox,
        'payservice-detail-footer': PayServiceDetailFooter,
        'amount-detail-payservice': AmountDetailPayService,
        'payservice-info': PayServiceInfo,
    }
})
export default class DetailPayService extends Vue {
    private payservice: PayServiceModel = new PayServiceModel();
    private customerInfo: any = {};
    get payserviceId() {
        return this.$route.params.id;
    }
    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    @Watch('payserviceId', { immediate: true, deep: true })
    private async watchOrderId() {
        if (this.payserviceId) {
            this.initComponent();
        }
    }

    private async initComponent() {
        await this.loadData();
        await this.getCustomersInfo();
    }

    private async loadData() {
        if (this.payserviceId) {
            const result = await payserviceService.getDetail(this.payserviceId);
            if (result && result.status === 200 && (result.data.data.length > 0 || result.data.data.ID > 0)) {
                const item = result.data.data;
                this.payservice = new PayServiceModel();
                this.payservice.id = item.ID;
                this.payservice.status = item.Status;
                this.payservice.statusDetail = DATA.payserviceStatus.find(x => x.value === item.Status) || { value: 0, name: '', color: '#3b4354' };
                this.payservice.uId = item.UID;
                this.payservice.userName = item.Username;
                this.payservice.exchangeRate = item.ExchangeRate;
                this.payservice.guaranteeRate = item.GuaranteeRate;
                this.payservice.guaranteeAmount = item.GuaranteeAmount;
                this.payservice.amount = item.Amount;
                this.payservice.amountVND = item.AmountVND;
                this.payservice.fee = item.Fee;
                this.payservice.feeAmount = item.FeeAmount;
                this.payservice.payment = item.Payment;
                this.payservice.totalAmount = item.TotalAmount;
                this.payservice.content = item.Content;
                this.payservice.bankAccountNumber = item.BankAccountNumber;
                this.payservice.bankAccountName = item.BankAccountName;
                this.payservice.bankName = item.BankName;
                this.payservice.images = item.Images;
                this.payservice.createdBy = item.CreatedBy;
                this.payservice.createdDate = item.CreatedDate;
            } else {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: `Không tìm thấy đơn ký gửi [${this.payserviceId}]`,
                });
            }
        }
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if(result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }
}
